enum ActionTypes {
  SET_TIME = 'SET_TIME'
}

export default ActionTypes;
